<template>
  <!-- FOOTER -->
  <footer>
    <p class="float-right aboutFootBtn" :class="{'aboutFootBtn-en':lang=='en'}"><a href="/contact">{{ $t('FOOTER.CONTACTUS') }}
    </a></p>
    <div class="footer-con">
      <ul>
        <li :class="{'footer-logo-en':lang=='en'}">
          <i></i>
        </li>
        <li :class="{'footer-info-en':lang=='en'}">
          <a>
            <i class="mail"></i><p :class="{'font-size-en':lang=='en'}">E-mail<span>|</span>crcb@mgt.ncu.edu.tw</p>
          </a>
          <a href="https://www.google.com/maps/search/%E6%A1%83%E5%9C%92%E5%B8%82%E4%B8%AD%E5%A3%A2%E5%8D%80%E4%B8%AD%E5%A4%A7%E8%B7%AF300+%E8%99%9F+%E5%BF%97%E5%B8%8C%E9%A4%A8+8+%E6%A8%93/@24.9695712,121.1933047,18z/data=!3m1!4b1" target="_blank">
            <i class="address" :class="{'address-en':lang=='en'}"></i><p :class="{'font-size-en':lang=='en'}">{{ $t('FOOTER.ADDRESS.TITLE') }}<span class="address-sp" :class="{'address-sp-en':lang=='en'}">|</span>{{ $t('FOOTER.ADDRESS.CONTENT') }}</p>
          </a>
        </li>
      </ul>
    </div>
    <div class="privacy">
      <a href="/privacy">{{ $t('FOOTER.PRIVACY') }}</a>
    </div>
  </footer>
</template>
<script>
import {fb, db } from '../../../firebase'
export default {
  name: 'Footer',
  data () {
    return {
      lang:''
    }
  },
  mounted () {
    this.lang = localStorage.getItem('language') || 'zh';
  },
  created(){
    this.Get();
  },
  methods: {
    Get(){
      db.collection(this.$t('DB.BANNER')).get().then((querySnapshot) => {
      }).catch((error) => {
        this.$router.push({name: 'Error'});
      });

    }
  }
}
</script>
<style scoped>
.ul-en{
  width: 100%;
  padding: 0px 20px;
}
.font-size-en{
  font-size:14px !important;
}
.address-sp-en{
  margin: 0px 16px 0px 7px !important;
}
.address-en{
  width:36px  !important;
}
@media (min-width: 576px) { 
  .address-en{
    margin-left:2px !important;
    margin-right:7px !important;
    width:32px  !important;
  }
}
@media (min-width: 768px) { 
  .address-en{
    margin-left:1px !important;
    width:22px  !important;
  }  
}
@media (min-width: 992px) { 
  .address-en{
    margin-left:2px !important;
    width:28px  !important;
  }  
}

@media (min-width: 1200px) { 
  .address-en{
    margin-left:2px !important;
    margin-right:7px !important;
    width:30px  !important;
  } 
}
@media (min-width: 1300px) { 
  .address-en{
    margin-left:2px !important;
    margin-right:7px !important;
    width:30px  !important;
  } 
}





.footer-logo-en{
  margin-right: 0px;
  margin-left: 0px;
}

.footer-info-en{
  margin-right: 10px;
  margin-left: 35px;
}

@media (min-width: 768px) { 
  .footer-info-en{
    margin-right: 20px;
    margin-left: 35px;
  } 
}


@media (min-width: 1100px) { 
  .footer-info-en{
    margin-right: 0px;
    margin-left: 0px;
  } 

  .footer-logo-en{
    margin-right: 100px;
    margin-left: 100px;
  }
}



@media (min-width: 1300px) { 
  .footer-info-en{
    margin-right: 0px;
    margin-left: 0px;
  } 

  .footer-logo-en{
    margin-right: 220px;
    margin-left: 200px;
  }
}


@media (max-width:1290px) {
  .aboutFootBtn-en{
    right: 50% !important;
    transform: translate(111px, 0px) !important;
  }
}



.ul-en li:first-child i {
    letter-spacing: 1px;
  }
@media (min-width: 1101px) { 
  .ul-en li:first-child{
    width:50%;
  }
 
}


</style>


// WEBPACK FOOTER //
// src/components/index/shared/Footer.vue